import { useAuth0 } from '@auth0/auth0-react';
import { Card, CardContent } from '@talentmesh/ui/components/card';
import { useEffect } from 'react';
import { Navigate } from 'react-router';
import { useMediaQuery } from 'usehooks-ts';
import AccordionPanel from './Components/AccordionPanel';
import VerifyEmailInstructions from './Components/VerifyEmailInstructions';
import MeshBackgroundCenterOverlay from '@/Components/layouts/MeshBackroundCenterOverlay';
import { CompanyLogo, LoadingOverlay } from '@/Components/shared';
import { useUserSignupNavigationContext } from '@/Context/UserSignupNavigationContext';
import RoutePath from '@/Routing/RoutePath';
import togglePageOverflow from '@/Utils/HTMLElementHelpers';
import UIStrings from '@/Utils/UIStrings';

/** Matches MUI `theme.breakpoints.down('md')` (max-width: 899px) for body overflow toggle. */
const useIsBelowMd = () => useMediaQuery('(max-width: 899px)');

function VerifyEmail() {
    const isBelowMd = useIsBelowMd();
    const { user } = useAuth0();
    const { isLoading } = useUserSignupNavigationContext();

    useEffect(() => {
        togglePageOverflow<HTMLBodyElement>('body', isBelowMd);
        return () => {
            togglePageOverflow<HTMLBodyElement>('body', isBelowMd);
        };
    }, [isBelowMd]);

    if (isLoading) {
        return <LoadingOverlay />;
    }

    if (user?.email_verified) {
        return <Navigate to={RoutePath.Provision} replace />;
    }

    return (
        <MeshBackgroundCenterOverlay>
            <CompanyLogo
                width={195}
                height={37.5}
                color="primary"
                className="mb-8 shrink-0"
                aria-label={UIStrings.CompanyLogo}
            />
            <Card className="border-border w-full overflow-hidden rounded-2xl border drop-shadow-xl">
                <CardContent className="p-0">
                    <VerifyEmailInstructions email={user?.email as string} />
                    <div className="border-border w-full border-t" role="separator" />
                    <AccordionPanel />
                </CardContent>
            </Card>
        </MeshBackgroundCenterOverlay>
    );
}

export default VerifyEmail;
